import axios from 'axios';
import {
  CategoriesGroupResponse,
  CategoriesParams,
  CategoriesResponse,
  CategoryDetailResponse,
} from '../types/Category';
import { baseUrl, HttpMethods } from './base';

const categoryBasePath = `${baseUrl.SHERPA}/categories`;
const categoryGroupBasePath = `${baseUrl.SHERPA}/categoryGroups`;

interface CategoryPayload {
  name: string;
  description: string;
  parentId?: number;
  categoryTypeId: number;
}

export interface CreateCategoryPayload extends CategoryPayload {}

export const createCategory = async (data?: CreateCategoryPayload) => {
  const response = await axios.request<CategoriesResponse>({
    url: categoryBasePath,
    method: HttpMethods.POST,
    data,
  });
  return response.data;
};

export const getCategories = async (params?: CategoriesParams) => {
  const response = await axios.request<CategoriesResponse>({
    url: categoryBasePath,
    method: HttpMethods.GET,
    params,
  });
  return response.data;
};

export const getCategory = async (id: number) => {
  const response = await axios.request<CategoryDetailResponse>({
    url: `${categoryBasePath}/${id}`,
    method: HttpMethods.GET,
  });
  return response.data;
};

export interface UpdateCategoryPayload {
  name: string;
  description: string;
  parentId: number;
  categoryTypeId: number;
}

export interface UpdateCategoryService {
  id: number;
  data: Partial<UpdateCategoryPayload>;
}

export const updateCategory = async ({ id, data }: UpdateCategoryService) => {
  const response = await axios.request({
    url: `${categoryBasePath}/${id}`,
    method: HttpMethods.PATCH,
    data,
  });
  return response.data;
};

export const getCategoriesGroup = async () => {
  const response = await axios.request<CategoriesGroupResponse>({
    url: `${categoryGroupBasePath}`,
    method: HttpMethods.GET,
  });
  return response.data;
};

export const getCategoriesSubgroup = async (params: {
  [key: string]: string | number | undefined;
}) => {
  const response = await axios.request({
    url: `${categoryGroupBasePath}/subgroup`,
    method: HttpMethods.GET,
    params,
  });
  return response.data;
};

export const getCategoriesByGroup = async (id: number) => {
  const response = await axios.request({
    url: `${categoryBasePath}/${id}`,
    method: HttpMethods.GET,
  });
  return response.data;
};

export const postDefaultCategories = async () => {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: `${categoryBasePath}/default`,
  });
  return res.data;
};
